<div class="pdf-viewer-modal">
  <ion-header class="ion-no-border pdf-viewer-modal__header-wrap" mode="ios">
    <ion-toolbar>
      <button class="pdf-viewer-modal__close-button" (click)="close()">
        <img
          src="/assets/images/icons-svg/arrow-right.svg"
          class="pdf-viewer-modal__close"
          alt="Закрыть"
        />
      </button>
    </ion-toolbar>
  </ion-header>

  <ion-content class="pdf-viewer-modal__content" [scrollY]="false" [forceOverscroll]="false">
    <div class="pdf-viewer-modal__container">
      @if (hasError()) {
        <div class="pdf-viewer-modal__loading-overlay">
          <div class="pdf-viewer-modal__error-icon">⚠️</div>
          <p class="pdf-viewer-modal__loading-message">{{ loadingMessage() }}</p>
          <app-button
            btnType="button-base"
            text="&nbsp;&nbsp;Скопировать ссылку&nbsp;&nbsp;"
            textSize="text-1"
            (click)="copyFileLink()"
          ></app-button>
        </div>
      } @else {
        <div
          class="pdf-viewer-modal__loading-overlay"
          [class.pdf-viewer-modal__loading-overlay--hidden]="!showLoadingIndicator()"
        >
          <div class="pdf-viewer-modal__spinner">
            <ion-spinner name="crescent"></ion-spinner>
          </div>
          <p class="pdf-viewer-modal__loading-message">{{ loadingMessage() }}</p>
        </div>
      }

      @if (pdfSrc(); as loadedPdf) {
        <ngx-extended-pdf-viewer
          class="pdf-viewer-modal__viewer"
          [src]="loadedPdf"
          [height]="viewerHeight"
          [language]="'ru'"
          [showToolbar]="false"
          [showOpenFileButton]="false"
          [showSidebarButton]="false"
          [showPrintButton]="false"
          (pdfLoadingFailed)="onPdfLoadingFailed()"
          (pageRendered)="onPageRendered()"
        ></ngx-extended-pdf-viewer>
      }
    </div>
  </ion-content>
</div>
